import classNames from 'classnames';
import siren from './siren.png';

export type SirenProps = {
  className?: string;
} & JSX.IntrinsicElements['img'];

export const Siren = ({ className, ...props }: SirenProps) => (
  <img src={siren} className={classNames('icon', className)} alt="siren" {...props} />
);
